import React from 'react'

import { Button, IButtonProps } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

interface IProps {
  onOpen: () => void
  isDisabled?: boolean
  isLoading?: boolean
  margin?: IButtonProps['margin']
}

export const ViewAllCriteriaButton = ({ onOpen, isDisabled, isLoading, margin }: IProps) => {
  return (
    <Tooltip tipContent={() => <span>No active criteria</span>} disabled={!isDisabled}>
      <Button onClick={onOpen} disabled={isDisabled} loading={isLoading} margin={margin}>
        Check Criteria Details
      </Button>
    </Tooltip>
  )
}
